
    import styled from 'styled-components';
    import * as Copy from 'styles/components/copy';
    import { ArrowElement } from 'styles/proj.components';

    // viewBox="220 220 170 370"
    // viewBox="0 0 612 792" preserveAspectRatio="xMaxYMid slice"
    
    const IconElement = ({className, ...props}) =>
        <svg className={className} width="612px" height="792px" viewBox="220 220 170 370">
            <g>
                <path className={ 'top_quarter' } d="M217.04,396.11c0,0.02,0,0.05,0,0.07H395.4V216.11C296.9,217.05,217.04,297.4,217.04,396.11z"/>
                <path className={ 'bottom_quarter' } d="M217.05,396.18c0.04,98.68,79.88,178.99,178.35,179.93V396.18H217.05z"/>
            </g>
        </svg>

    export const Content = styled.div`
        display: flex;
        position: relative;

        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;

        width: 100%;
        margin: 0 auto;
        padding: 0 20px 30px;
        align-self: flex-end;
        flex: 1 0 auto;

        ${({theme}) => theme.breakpoints['sm']}
        {
            padding: 0 20px 50px;
        }
    `;

    export const Icon = styled(IconElement)`
        width: 20px;
        height: 40px;
        margin-bottom: 10px;

        .top_quarter { fill: #378B42; }
        .bottom_quarter { fill: #6CBE55; }

        .fitness &
        {
            .top_quarter { fill: #ccaa00; }
            .bottom_quarter { fill: #ffdf25; }
        }

        .food &
        {
            .top_quarter { fill: #e0003e; }
            .bottom_quarter { fill: #ff3d7c; }
        }

        .sleep &
        {
            .top_quarter { fill: #0791bc; }
            .bottom_quarter { fill: #5cd7f8; }
        }

        .relationships &
        {
            .top_quarter { fill: #71138f; }
            .bottom_quarter { fill: #b847ce; }
        }

        .mindfulness &
        {
            .top_quarter { fill: #85ac01; }
            .bottom_quarter { fill: #bbe223; }
        }
    `;

    export const Title = styled(Copy.ParagraphElement)`
        display: flex;
        font-family: CNN Condensed;
        font-weight: 200;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 1.52px;
        max-width: 500px;
        padding: 0;
        margin: 0 0 14px;

        ${({theme}) => theme.breakpoints['sm']}
        {
            font-size: 21px;
            line-height: 32px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            font-size: 28px;
            line-height: 39px;
        }

        strong
        {
            margin-bottom: 20px;
            font-weight: 500;
        }
    `;

    export const ButtonContainer = styled.div`
        display: flex;
        position: relative;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 20px;
        width: 100%;

        ${({theme}) => theme.breakpoints['sm']}
        {
            margin-top: 40px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            margin-top: 40px;
            flex-direction: row;
        }
    `;

    export const ButtonArrowIcon = styled(ArrowElement)`
        display: flex;
        position: relative;
        flex-direction: row;
        margin-right: 10px;
        height: 40px;
        width: 40px;

        flex: 1 0 auto;
        
        ${({theme}) => theme.breakpoints['md']}
        {
            height: 44px;
            width: 45px;
        }
    `;

    export const ButtonLabel = styled(Copy.ParagraphElement)`
        font-family: CNN Condensed;
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        line-height: 1.2em;
        letter-spacing: 1.3px;
        color: #000000;

        margin: 0;
        padding: 0;

        ${({theme}) => theme.breakpoints['sm']}
        {
            font-size: 18px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            font-size: 24px;
        }
    `;

    export const Button = styled.div`
        user-select: none;
        cursor: pointer;
        display: flex;
        position: relative;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        
        flex: 0 1 auto;

        ${ButtonArrowIcon}
        {
            .circle,
            .arrow
            {
                transition: fill 250ms;
            }
        }
        
        &:last-child
        {
            margin-right: 0px;
        }

        &:hover 
        {
            ${ButtonArrowIcon}
            {
                .circle
                {
                    fill: white;
                }

                .arrow
                {
                    fill: black;
                    animation: animation-arrow-hover 500ms ease-in-out 0ms 1 normal forwards running;
                }
            }
        }

        @keyframes animation-arrow-hover
        {
            0%
            {
                
                transform: translate(0%, 0%);
            }

            50%
            {
                transform: translate(100%, 0%);
            }

            51%
            {
                transform: translate(-100%, 0%);
            }

            100%
            {
                transform: translate(0%, 0%);
            }
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            margin-bottom: 0;
            margin-right: 20px;
        }
    `;

    export const MenuContainer = styled.div`
        display: flex;
        position: relative;
        flex-direction: row;

        flex: 1 1 auto;
    `;